import axios from "axios";
import { API_URL } from "constants";

/**
 * @param {string} companyId
 * @param {{ subjectType?: string, subjectId?: string, limit?: number, skip?: number, action?: string, userId?: string }} query
 */
export const fetchAuditLogs = async (companyId, query = {}) => {
  const params = new URLSearchParams();
  if (query.subjectType) params.set("subjectType", query.subjectType);
  if (query.subjectId) params.set("subjectId", query.subjectId);
  if (query.limit != null) params.set("limit", String(query.limit));
  if (query.skip != null) params.set("skip", String(query.skip));
  if (query.action) params.set("action", query.action);
  if (query.userId) params.set("userId", query.userId);
  const qs = params.toString();
  const url = `${API_URL}/${companyId}/audit-logs${qs ? `?${qs}` : ""}`;
  return axios.get(url).then((r) => r.data);
};
